import { Trans } from 'react-i18next';
import Section from '../../../components/mplat/Section';
import { AccountResType } from '../../../services/users_v1';
import { AccountsListProps } from '../types';
import Account from './Account';

function AccountsList({ list }: AccountsListProps) {
    return (
        <Section label={undefined}>
            <div className="user-settings__list">
                {list.length > 0 ?
                    (
                        list.length === 1 ?
                            list.map(item => <Account key={item.id} item={item} />)
                            :
                            list.filter((item) => item.rtype !== AccountResType.GUEST).map(item => <Account key={item.id} item={item} />)
                    )
                    :
                    <div className="user-settings__list-item" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <Trans>account:NO_ROLES</Trans>
                    </div>
                }
            </div>
        </Section>
    );
}

export default AccountsList;
